<template>
  <div>
    <b-form-group label-align="right" v-if="ssrIsEnabled.length>0" :label="$t('Enabled')" label-cols="1" label-cols-xl="1" label-cols-md="1">
        <b-form-checkbox size="lg" @change="ChangeSSRIsEnabled" switch class="mt-2" v-model="ssrIsEnabled[0].raw_values[0].value" unchecked-value="0" value="1" style="max-width:100px"/>
    </b-form-group>
    <b-form-group label-align="right" v-if="ssrServiceID.length>0" :label="$t('Service')" label-cols="1" label-cols-xl="1" label-cols-md="1">
        <b-form-select @change="ChangeSSRServiceID" v-model="ssrServiceID[0].raw_values[0].value" :options="services" style="max-width:400px"/>
    </b-form-group>
  </div>
</template>

<script>
export default {
  methods: {
    ChangeSSRIsEnabled (checked) {
      let tmp = JSON.parse(JSON.stringify(this.ssrIsEnabled[0]))
      tmp.object_id = 0
      tmp.raw_values[0].value = String(checked)
      this.$store.dispatch('Settings/UPDATE_REGISTRY_SETTING', tmp).then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          this.$root.$emit('makeToasts')
        }
      })
      setTimeout(this.$store.dispatch, 500, 'Settings/GET_REGISTRY_SETTINGS', {group_id: 19, object_id: 0})
    },
    ChangeSSRServiceID (newValue) {
      let tmp = JSON.parse(JSON.stringify(this.ssrServiceID[0]))
      tmp.object_id = 0
      tmp.raw_values[0].value = String(newValue)
      this.$store.dispatch('Settings/UPDATE_REGISTRY_SETTING', tmp).then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          this.$root.$emit('makeToasts')
        }
      })
      setTimeout(this.$store.dispatch, 500, 'Settings/GET_REGISTRY_SETTINGS', {group_id: 19, object_id: 0})
    }
  },
  computed: {
    ssrIsEnabled () {
      return this.$store.getters['Settings/REGISTRY_SETTINGS'].filter(el => {
        return el.name === 'sir_is_enabled'
      })
    },
    ssrCoAIsEnabled () {
      return this.$store.getters['Settings/REGISTRY_SETTINGS'].filter(el => {
        return el.name === 'sir_is_enabled'
      })
    },
    ssrServiceID () {
      return this.$store.getters['Settings/REGISTRY_SETTINGS'].filter(el => {
        return el.name === 'sir_service_id'
      })
    },
    services () {
      let copy = JSON.parse(JSON.stringify(this.$store.getters['Tariffing/SERVICES']))
      copy = copy.filter(function (value) {
        return value.parent_id === 0 && value.service_type === 1
      })
      let res = []
      res.push({value: 0, text: this.$t('Not select')})
      for (let el of copy) {
        let newEl = {}
        newEl.value = el.service_id
        newEl.text = el.service_name
        res.push(newEl)
      }
      return res
    }
  },
  mounted () {
    this.$store.dispatch('Settings/GET_REGISTRY_SETTINGS', {group_id: 19, object_id: 0})
    this.$store.dispatch('Tariffing/GET_SERVICES')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/customerPortal/sirService/main.vue